import React from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import injectReducer from 'utils/injectReducer'
import reducer from './reducer'
import {loadVerifyingCreds} from './actions'
import {
  selectFirstVerifyingCredential,
  selectIsPhoneSession,
  selectIs2faEnabled,
  selectNeedPasswordConfirmation,
  selectNeedPhoneConfirmation
} from './selectors'

export const withVerifyingData = (method) => (Component) => {
  class VerifyingData extends React.Component {
    static displayName = `withVerifyingData(${
      Component.displayName || Component.name || 'Component'
    })`

    static propTypes = {
      loadVerifyingCreds: PropTypes.func,
      firstVerifyingCredential: PropTypes.object,
      isPhoneSession: PropTypes.bool,
      is2faEnabled: PropTypes.bool,
      needPasswordConfirmation: PropTypes.bool,
      needPhoneConfirmation: PropTypes.bool
    }

    UNSAFE_componentWillMount() {
      this.props.loadVerifyingCreds(method)
    }

    render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {loadVerifyingCreds, ...props} = this.props

      return <Component {...props} />
    }
  }

  const mapStateToProps = createStructuredSelector({
    firstVerifyingCredential: selectFirstVerifyingCredential,
    isPhoneSession: selectIsPhoneSession,
    is2faEnabled: selectIs2faEnabled,
    needPasswordConfirmation: selectNeedPasswordConfirmation,
    needPhoneConfirmation: selectNeedPhoneConfirmation
  })

  function mapDispatchToProps(dispatch) {
    return {
      loadVerifyingCreds: (method) => dispatch(loadVerifyingCreds(method))
    }
  }

  const withConnect = connect(mapStateToProps, mapDispatchToProps)
  const withReducer = injectReducer({key: 'verifyingData', reducer})

  return compose(withReducer, withConnect)(VerifyingData)
}
